export const LEAVES_SESSIONS= [
    { 
        id: "1",
        session_name : "Session-1"
    },
    { 
        id: "2",
        session_name : "Session-2"
    }
]